/**
 * SpiffArena backend が set した認証 cookie の読み取り。
 *
 * cookie を書くのは backend（login_return の Set-Cookie）であり、フロントは読むだけ。
 * HttpOnly ではないため document.cookie から参照できる。
 */

export type AuthCookies = {
  readonly accessToken: string | null;
  readonly idToken: string | null;
  readonly authenticationIdentifier: string | null;
};

/** `document.cookie` 形式の文字列を key/value に分解する。 */
export function parseCookieHeader(raw: string): Record<string, string> {
  const result: Record<string, string> = {};

  for (const fragment of raw.split(";")) {
    const separator = fragment.indexOf("=");
    // `=` を含まない断片は cookie ではない
    if (separator === -1) continue;

    const name = fragment.slice(0, separator).trim();
    if (name === "") continue;

    // 値に `=` を含む JWT を切り落とさないよう最初の `=` だけで分割する
    const rawValue = fragment.slice(separator + 1).trim();
    result[name] = safeDecode(rawValue);
  }

  return result;
}

/** SpiffArena が set する 3 つの cookie を取り出す。空文字は未設定として null にする。 */
export function readAuthCookies(raw: string): AuthCookies {
  const cookies = parseCookieHeader(raw);

  return {
    accessToken: nonEmptyOrNull(cookies.access_token),
    idToken: nonEmptyOrNull(cookies.id_token),
    authenticationIdentifier: nonEmptyOrNull(cookies.authentication_identifier),
  };
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    // 不正なパーセントエンコードでも例外にせず生値を返す
    return value;
  }
}

function nonEmptyOrNull(value: string | undefined): string | null {
  return value === undefined || value === "" ? null : value;
}
